import styled from 'styled-components'

type Props = {
	size: number
}

export const Container = styled.div<Props>`
	position: relative;
	width: ${({ size }) => size}px;
	height: ${({ size }) => size}px;
`
